module.exports = __webpack_public_path__ + "fonts/ralewaylight.c85acbb.woff2";